'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OrderConfig = exports.OrderConfig = function OrderConfig($stateProvider) {
  'ngInject';

  $stateProvider.state('app.orderlisting', {
    url: '^/orders',
    template: '<orders-listing></orders-listing>'
  });
  $stateProvider.state('app.orderView', {
    url: '^/order-details-view/:id',
    template: '<order-view></order-view>'
  });
};

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/orders/components/order.config.js
 **/